export default "__VITE_ASSET__HeLFdw_X__"